<div
  [ngClass]="{
    'news-carousel__container': true,
    'news-carousel__container--collapsed': isVisible === false,
  }"
>
  @if (isVisible === true) {
    <div class="news-carousel container">
      <mb-carousel [entities]="newsArray" [autoplay]="true">
        <ng-container *mbCarouselItem="let news; let i = index">
          <div
            [matTooltip]="'Go to news article'"
            [ngClass]="{ news: true, 'news--first': i === 0 }"
          >
            <a class="news-link" [routerLink]="'/news/' + news.id">{{ news.headline }}</a>
          </div>
        </ng-container>
      </mb-carousel>
    </div>
  }
  <!-- /news-carousel -->

  @if (isLoading === false) {
    <div
      [ngClass]="{
        'news-carousel__toggle': true,
        'news-carousel__toggle--collapsed': isVisible === false,
      }"
    >
      <!-- @if (isVisible === true) {
    <button mat-icon-button (click)="toggle()" matTooltip="Hide news">
      <mat-icon>cancel</mat-icon>
    </button>
    } @if (isVisible === false) {
    <button mat-stroked-button (click)="toggle()" matTooltip="Display news">
      Display news
    </button>
    } -->
    </div>
  }
  <!-- /news-carousel__toggle -->
</div>
<!-- /news-carousel__container -->
